import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

const api = axios.create({
  baseURL: API_BASE,
});

/**
 * Absolute URL for a file the API serves from /uploads (project logos,
 * ticket attachments). Paths are stored relative so they survive the API
 * moving hosts; anything already absolute is passed straight through.
 */
export function assetUrl(pathOrUrl) {
  if (!pathOrUrl) return '';
  if (/^(https?:)?\/\//i.test(pathOrUrl) || pathOrUrl.startsWith('data:')) return pathOrUrl;
  return `${API_BASE.replace(/\/api\/?$/, '')}/${pathOrUrl.replace(/^\//, '')}`;
}

// Attach auth token and active tenant to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;

  try {
    const tenant = JSON.parse(localStorage.getItem('activeTenant'));
    if (tenant?.id) config.headers['X-Tenant-ID'] = tenant.id;
  } catch { /* ignore */ }

  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('activeTenant');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  },
);

export default api;
